// @ts-nocheck

import { BasketActionTypes } from '../../../types/actions/basket';
import { MPStateActionTypes } from '../types/actions/mp';

export const updateMPUserState = ({ userStateMutation }) => ({
  type: MPStateActionTypes.UPDATE_STATE,
  payload: {
    userStateMutation,
  },
});

export const claimAllMPRewards = ({ uuids }) => ({
  type: MPStateActionTypes.CLAIM_ALL_REWARDS,
  payload: {
    uuids,
  },
});

export const claimMPReward = ({ uuid }) => ({
  type: MPStateActionTypes.CLAIM_REWARD,
  payload: {
    uuid,
  },
});

export const flushNotifications = () => ({
  type: MPStateActionTypes.FLUSH_NOTIFICATIONS,
});

export const registerMPAdventure = (hooks) => ({
  type: MPStateActionTypes.REGISTER,
  hooks,
});

export const skipCurrentTemporaryNotification = () => ({ type: MPStateActionTypes.SKIP_CURRENT_TMP_NOTIFICATION });

export const fillTemporaryMPNotification = () => ({ type: MPStateActionTypes.FILL_TEMPORARY_NOTIFICATIONS });

export const skipAllMPTemporaryNotifications = () => ({ type: MPStateActionTypes.SKIP_ALL_TMP_NOTIFICATIONS });

export const recomputeNextMPBasketState = () => ({
  type: BasketActionTypes.RECOMPUTE_NEXT_MP_BASKET_STATE,
});
